import React, { useRef, useEffect } from "react";

import {
  AddMsgWrapper,
  ToggleSwitch,
  PersonalisationErrorModal,
} from "../../styles";

const AddMessage = ({
  personalisationSelected,
  setPersonalisationSelected,
  editable,
  selection,
  charLimit,
  setSelection,
  clearMultiMessage,
  focusedProduct,
  setFocusedProduct,
  singleMessage,
  setSingleMessage,
  isMobile,
  isMini,
}) => {
  useEffect(() => {
    !bundlePersonalisable() ? setPersonalisationSelected(false) : null;
  }, [selection]);

  const PersonalisationWarning = useRef();

  const handlePersonalisationSwitch = () => {
    if (!bundlePersonalisable()) {
      PersonalisationWarning.current.classList.add("active");
    } else {
      !editable ? togglePersonalisation() : null;
    }
  };

  const togglePersonalisation = () => {
    if (!personalisationSelected) {
      setPersonalisationSelected(true);
    } else {
      focusedProduct ? setFocusedProduct(null) : null;
      singleMessage ? setSingleMessage(false) : null;
      clearMultiMessage();
      setPersonalisationSelected(false);
    }
  };

  const bundlePersonalisable = () => {
    let p = selection.filter((item) => item !== null);
    if (p.length > 0) {
      return p.filter((item) => item.personalisation_available === "Y").length
        ? true
        : false;
    } else {
      return true;
    }
  };

  const handleWarningClose = (e) => {
    e.preventDefault();
    PersonalisationWarning.current.classList.remove("active");
  };

  return (
    <>
      <PersonalisationErrorModal ref={PersonalisationWarning}>
        <div className="inner">
          <p>None of the cupcakes you have selected can be personalised!</p>
          <button className="mt-3" onClick={(e) => handleWarningClose(e)}>
            ok
          </button>
        </div>
      </PersonalisationErrorModal>
      <AddMsgWrapper
        className={`${personalisationSelected ? "activated" : ""}${
          editable || !bundlePersonalisable() ? " faded" : ""
        }`}
      >
        <div className="d-flex justify-content-between">
          <h6 className="tt-title">Add a personal message to your cupcakes?</h6>
          <ToggleSwitch
            onClick={() => handlePersonalisationSwitch()}
            className={`ml-3 ${personalisationSelected ? "active" : ""}`}
          />
        </div>
        <p>
          {`${
            isMobile ? "Add your message in the next step." : ""
          } ${isMini ? "65p" : "75p"} charge per cupcake, 20 chars
          max (capitals count as 2). Cupcake decorations may be removed or icing
          flattened to make space for writing.`}
        </p>
      </AddMsgWrapper>
    </>
  );
};

export default AddMessage;
